import React from 'react'
import { Link } from 'react-router-dom'

function AboutFounderPrivacy() {
    return (
        <section className="about-founder td-section td-section--about-founder rts-section-gap">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-9">
                        <div className="about-founder-panel">
                            <h3 className="about-founder-panel__title">A Note on Who We Are</h3>
                            <p className="disc">
                                You won&apos;t find founder names or photographs on this website. That&apos;s an
                                intentional choice.
                            </p>
                            <p className="disc">
                                In industries where personal data is currency and targeted outreach is constant,
                                we&apos;ve decided to let our work speak louder than our LinkedIn profiles. Our team
                                handles sensitive client data every day—and we take the same privacy principles
                                seriously when it comes to ourselves.
                            </p>
                            <p className="disc">
                                What we will tell you is this: our founding team has backgrounds in healthcare IT and
                                operations, every team member is properly credentialed and background-checked for their
                                role—and the people who built this company are still the ones running it.
                            </p>
                            <p className="disc about-founder-panel__closing">
                                If you want to know more about who&apos;s behind TechDigit Solutions, that conversation
                                happens on the first consultation call, which is always free. We&apos;d rather earn your
                                trust in person than sell it to you on a webpage.
                            </p>
                            <Link to="/contactus" className="rts-btn btn-primary">
                                Schedule Your Free Consultation
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutFounderPrivacy
